import { render, staticRenderFns } from "./config-providers.vue?vue&type=template&id=1c3794a5"
import script from "./config-providers.vue?vue&type=script&lang=js"
export * from "./config-providers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports